import React, {  useState, useEffect ,useRef} from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import Modal from "./Modalxl";
import ReactPaginate from "react-paginate";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {aPIURL,auTHURL,removeUserSession, setUserSession} from '../utils/common';
import { useNavigate  } from "react-router-dom";
import CDashboard from "./ClientApplication/CLVehicleList";
import { useReactToPrint } from 'react-to-print';
//import { useDownloadExcel } from "react-export-table-to-excel";
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import apprt from '../App';


const CustomerList = () => 
{
  const fileType ="xlsx";
  const tableRef = useRef(null);
  const API_URL=aPIURL();
  const AUTH_URL= auTHURL();

  const [actionId , setActionId]= useState('1');
  const [custType ,setCustType] = useState(1);
  const [cstatusId ,setCstatusId] = useState('0');
  const [custID, setCustID] = useState('0');
  const [customerTypeId, setCustomerTypeId] = useState(0);

  const [stateId, setStateId]= useState( '');
  const [countryId, setCountryId]= useState('1');                                
  const [custGST ,setCustGST]= useState("");   
  const [dActionname, setDActionname]= useState('Save');
  const [cDisplay, setCDisplay]= useState('none');
  const [mLogincDisplay, setMLogincDisplay]= useState('none');
  const [cNameLevel, setCNameLevel]= useState('Customer');           
  const [countryData, setCountryData] = useState([]);
  const [stateData, setStateData]= useState([]);
  
  const [post, setPost] = useState([]);
  const [order, setOrder] = useState("ASC");
  const [number, setNumber] = useState(1); // No of pages
  const [postPerPage] = useState(10);
  const [inputs, setInputs] = useState({});

  const [StatusData, setStatusData]= useState([]);
  const [customerData, setCustomerData]= useState([]);
  const [filteredCustomerDetails,setFilteredCustomerDetails]= useState([]);
  const [allotedDeviceByCustID, setAllotedDeviceByCustID]= useState([]);
  const [showAddDetails, setShowAddDetails]= useState(false);
  const [showDetails, setShowDetails]= useState(false);
  const [changePass, setChangePass]= useState(false);
  const [redioDispl, setRedioDispl]= useState(false);
  const [resetPassword,setResetPassword]  = useState('none');
  let [custTypeId, setCustTypeId]= useState(0);
  let [userMax, setUserMax]= useState(0);
  let [custName , setCustName]= useState('');   
  let [custMobile , setCustMobile]= useState('');   

  const history = useNavigate();
 const navigate = useNavigate();


  useEffect(() => {
       
    const curls=API_URL+'countries';
    axios.post(curls).then(response => {                            
    setCountryData(response.data.data)
     }).catch(function(error){console.log(error.message);});
        
     const surls=API_URL+`states?Country_ID=1`;
     axios.post(surls).then(response => {                            
      setStateData(response.data.data)
       }).catch(function(error){console.log(error.message);});
    
    //grid binding start 
    FillGrid(0);    
    

  }, []);
  
  const lastPost = number * postPerPage;
  const firstPost = lastPost - postPerPage;
  const currentPost = post.slice(firstPost, lastPost);
  const PageCount = Math.ceil(post.length / postPerPage);

const FillGrid=(Type_ID)=>
{   
        const curls=API_URL+`GpsCustomerAllList/?TypeID=${Type_ID}`;       
        axios.post(curls).then(response => {  
        console.log("----------------------------------Fill Grid------------------------------");    
        console.log(response.data.data);                     
        setPost(response.data.data);
     }).catch(function(error)
     {
         console.log(error.message);
     });   
    
}

const ChangePage = ({ selected }) => {
       
        setNumber(selected+1);
};
              
const showAddCustomerDetails=()=>
{
         setMLogincDisplay('none');
         setShowAddDetails(true);
         setShowDetails(false);  
         //setInputs({});  
         setStateId('');
         setCountryId('1');  
         setChangePass(false);
         setResetPassword('none');   
         setRedioDispl(false);
         setUserMax(0);   
         inputs.CustPassword= "Avaal@123";                 
} 

const closeAddCustomerModal = () => 
{
       setActionId('1'); 
       setDActionname('Save');
       setShowAddDetails(false);
       setShowDetails(false);  
       bindCustomerDetails();
       setInputs({});  
       setChangePass(false);         
}  

const showDetailsModal = (index) => {
          
    const d_Id = index;       
    const updatedCustomerList = post.filter((custElem) => {          
    
      return custElem.accountID === d_Id; 
    });
   
    setFilteredCustomerDetails(updatedCustomerList);   
    
    console.log("-----------------------------------------updatedCustomerList----------------------------------------------");
    console.log(updatedCustomerList);
    
    bindAllottedDevice(d_Id);                
    setShowDetails(true);  
    setShowAddDetails(false);

}
const closeModal = () => {
     setShowDetails(false);
     setShowAddDetails(false); 
      
}
const sorting=(col)=>
{
  try
  {
    if(order==="ASC")
    {
            const sorted=[...post].sort((a,b)=>
            a[col].toLowerCase() > b[col].toLowerCase() ? 1: -1
            );
            setPost(sorted);
            setOrder("DSC");
    }
    if(order==="DSC")
    {
            const sorted=[...post].sort((a,b)=>
            a[col].toLowerCase() < b[col].toLowerCase() ? 1: -1
            );
            setPost(sorted);
            setOrder("ASC");
    }
  }
  catch(error) 
  {
    console.log(error.message);
  }  
          
}
const bindCustomerDetails=()=>
{
      //grid binding start 
        FillGrid(custTypeId);
       //grid binding end       
}

const bindAllottedDevice=(ca_Id)=>
{
    setAllotedDeviceByCustID([]);
    const adurls = API_URL+`AllotmentDeviceList/?AccountID=${ca_Id}`;    
    axios.get(adurls).then(response => {                         
        setAllotedDeviceByCustID(response.data.data);
    }).catch(function(error) {  console.log(error.message); });
}

const handleEdit=(index) => {
          
  const C_Id = index;                        
  const urls=API_URL+`GetGPSCustomerDetails/${C_Id}/`;
     
  axios.post(urls).then(response => 
  {
         
      setMLogincDisplay('block');
      setActionId('2'); 
      setDActionname('Update');
      setCustID(response.data.data[0].accountID);  
      setCountryId(response.data.data[0].countryID); 
      setStateId(response.data.data[0].stateID);    
      setChangePass(true); 
      setResetPassword('block');   
      setCustType(response.data.data[0].customerTypeID); 
      setCustGST(response.data.data[0].gstNumber);  
      setRedioDispl(true);

      if(response.data.data[0].customerTypeID ==1)
      {
            setCDisplay('none');
            setCNameLevel('Customer');
      }
      else if(response.data.data[0].customerTypeID ==2)
      {
             setCDisplay('block');
             setCNameLevel('Company');
      }
      else 
      {
             setCDisplay('block');
             setCNameLevel('Distributor');
      }
      
           inputs.CustName=response.data.data[0].fullName;
           inputs.CustMobile= response.data.data[0].mobileNo;
           inputs.CustEmail= response.data.data[0].email;
           inputs.CustCompany= response.data.data[0].company;
           inputs.CustCity= response.data.data[0].city;
           inputs.CustPinCode= response.data.data[0].pinCode;
           inputs.CustUserName= response.data.data[0].userName;
           inputs.CustPassword= "Avaal@123";
           inputs.CustAddress= response.data.data[0].address; 
           inputs.CustCompanyWebsite= response.data.data[0].website;
           inputs.ContactPerson= response.data.data[0].contactName; 
           inputs.ContactNumber= response.data.data[0].contactPhone; 
           inputs.ContactEmail= response.data.data[0].contactEmail;    
           inputs.GSTNumber= response.data.data[0].gstNumber;  
           setUserMax(response.data.data[0].userMax);
                    
                                                             
  }
  ).catch(function (error) {
     
    console.log(error.message);
        
 });   
        setShowAddDetails(true);
        setShowDetails(false);   
              
}

const setCustomerType=(event) =>
{
     if(event.target.value==1)
     {
           setCustType(1);           
           setCDisplay('none');
           setCNameLevel('Customer');
     }
     else if(event.target.value==2)
     {
           setCustType(2);            
           setCDisplay('block');
           setCNameLevel('Company');
     }
     else
     {
           setCustType(3);            
           setCDisplay('block');
           setCNameLevel('Distributor');
     }
       
     
}
const ChangeStateD = (e) => {

    setStateId(e.target.value);   

}
const ChangeCountryD = (e) => {

    setCountryId(e.target.value);
    if(actionId==="1") // && (inputs.CustUserMax==='' || (!inputs.CustUserMax)))
    {
           setUserMax(0);
      //inputs.CustUserMax=0;
    }
  }

const changeHandler = (event) => {
if(event.target.name==='CustMobile')
  {
        const re = /^[0-9\b]+$/;
        if (event.target.value === '' || re.test(event.target.value)) 
        {
         
              const name = event.target.name;
             //alert(name);
             const value = event.target.value;
              setInputs(values => ({...values, [name]: value}))
        }
        else
        {
          setInputs(values => ({...values, ['CustMobile']: ""}))
              
        }
        
  }
  else if(event.target.name==='CustPinCode')
  {
        const re1 = /^[0-9\b]+$/;
        if (event.target.value === '' || re1.test(event.target.value)) 
        {
              const name = event.target.name;
             //alert(name);
             const value = event.target.value;
              setInputs(values => ({...values, [name]: value}))
        }
        else
        {
          setInputs(values => ({...values, ['CustPinCode']: ""}))
           
        }
        
  }
  else if(event.target.name==='ContactNumber')
  {
        const re2 = /^[0-9\b]+$/;
        if (event.target.value === '' || re2.test(event.target.value)) 
        {
              const name = event.target.name;
             //alert(name);
             const value = event.target.value;
              setInputs(values => ({...values, [name]: value}))
        }
        else
        {
          setInputs(values => ({...values, ['ContactNumber']: ""}))
        }
        
  }
    else if(event.target.name==='CustUserMax')
  {
        const re2 = /^[0-9\b]+$/;
        if (event.target.value === '' || re2.test(event.target.value)) 
        {
              const name = event.target.name;
             //alert(name);
             const value = event.target.value;
              setInputs(values => ({...values, [name]: value}))
        }
        else
        {
          setInputs(values => ({...values, ['CustUserMax']: ""}))
        }
        
  }
  else
  {
      const name = event.target.name;
      const value = event.target.value;
      setInputs(values => ({...values, [name]: value}))
  }
}
            
const onClickResetPassword=()=>
{
      if(!inputs.CustUserName && inputs.CustUserName==='')  
      {
              toast.error("UserName is required.");
              return;
      }
      else if(!inputs.CustPassword && inputs.CustPassword==='')  
      {
              toast.error("Password is required.");
              return;
      }
      //Password validation starts
      if (inputs.CustPassword.length < 8) 
      {
        toast.error('Invalid password, password must contain greater than or equal to 8 characters.')
        return
      }

        let countUpperCase = 0
        let countLowerCase = 0
        let countDigit = 0
        let countSpecialCharacters = 0
        let password = inputs.CustPassword;
        for (let i = 0; i < password.length; i++) 
        {
        const specialChars = ['!', '@','#','$','%','^','&','*','(',')','_','-','+','=','[','{',']','}',':',';','<','>', ]

        if (specialChars.includes(password[i])) 
        {
              countSpecialCharacters++
        } 
        else if (!isNaN(password[i] * 1)) 
        {
            countDigit++
        } 
        else 
        {
            if (password[i] == password[i].toUpperCase()) 
              {
                  countUpperCase++
              }
            if (password[i] == password[i].toLowerCase()) 
             {
                countLowerCase++
             }
        }
      }

if (countLowerCase == 0) {
  toast.error('Invalid password, no lower case characters in password')
  return
}

if (countUpperCase == 0) {
  toast.error('Invalid password, no upper case characters in password')
  return
}

if (countDigit == 0) {
  toast.error('Invalid password, no digit characters in password')
  return
}

if (countSpecialCharacters == 0) {
  toast.error('Invalid password, no special characters in password')
  return
}
//Password validation ends
const resetpasswordparams = JSON.stringify({     
  
            "password": inputs.CustPassword,
  	        "confirmPassword": inputs.CustPassword,
 	          "email": inputs.CustEmail,
  	        "token": ""      
      });      
   axios.post(AUTH_URL+'ResetPassword', resetpasswordparams, {            
    "headers": 
    {
         "content-type": "application/json",   
    },
    })
    .then(function (response) 
    {
        if(response.data.statusCode === 1)  
         {
              toast.success("Password Changed Successfully");
         }
         else
         {
               toast.error(response.data.message);       
            
         }
    })
    .catch(function (error) 
    {
              toast.error("Some Error occured while saving customer record,Please Provide Valid Inputs.");     
     
    });   

}
const onClickRegister = () => {  
  
  if(!inputs.CustName && custType===1)  
  {
    
    toast.error("Name is required.");
    return;
   }
  else if(inputs.CustName===''  && custType===1)
  {
    toast.error("Name is required.");
     return;
  }
  if(!inputs.CustName && custType===2)  
  {
    toast.error("Company name is required.");
    return;
   }
  else if(inputs.CustName===''  && custType===2)
  {
    toast.error("Company name is required.");
     return;
  }
  else if(!inputs.CustMobile)
  {
    toast.error("Customer mobile number is required.");
    return;
  }
  else if(inputs.CustMobile==='')
  {
    toast.error("Customer mobile number is required.");
    return;
  }
  else if(inputs.CustMobile.length<10 || inputs.CustMobile.length>10)
  {
    toast.error("Customer mobile number should be 10 digits.");
    return;
  }
  else if(!inputs.CustEmail)
  {
       toast.error("Customer email is required.");
       return;
  }
  else if(inputs.CustEmail==='')
  {
       toast.error("Customer email is required.");
       return;
  }
  else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(inputs.CustEmail))
  {
       toast.error("Customer email is invalid.");
       return;
  }  
  else if(!countryId)
  {
        toast.error("Country is required.");
        return;
  }
  else if(countryId==='')
  {
         toast.error("Country is required.");
         return;
  }
  else if(!stateId)
  {
         toast.error("State is required.");
         return;
  }
  else if(stateId==='')
  {
         toast.error("State is required.");
         return;
  }
  else if(!inputs.CustCity)
  {
       toast.error("City name is required.");
       return;
  }
  else if(inputs.CustCity==='')
  {
        toast.error("City name is required.");
        return;
  }
  else if(!inputs.CustPinCode)
  {
        toast.error("Pincode is required.");
       
       return;
  }
  else if(inputs.CustPinCode==='')
  {
        toast.error("Pincode is required.");
        return;
  }  
  else if(!inputs.CustUserName)
  {
        toast.error("Username is required.");
        return;
  }  
  else if(inputs.CustUserName==='')
  {
        toast.error("Username is required.");
        return;
  }
  else if(inputs.CustPassword==='')
  {
        toast.error("Password is required.");
        return;
  }
  else if(!inputs.CustPassword)
  {
       toast.error("Password is required.");             
       return;
  }
//Password validation starts
if (inputs.CustPassword.length < 8) {
  toast.error('Invalid password, password must contain greater than or equal to 8 characters.')
  return
}

let countUpperCase = 0
let countLowerCase = 0
let countDigit = 0
let countSpecialCharacters = 0
let password = inputs.CustPassword;
for (let i = 0; i < password.length; i++) {
  const specialChars = [
    '!', '@','#','$','%','^','&','*','(',')','_','-','+','=','[','{',']','}',':',';','<','>', ]

  if (specialChars.includes(password[i])) {
        countSpecialCharacters++
  } else if (!isNaN(password[i] * 1)) {
        countDigit++
  } else {
    if (password[i] == password[i].toUpperCase()) {
          countUpperCase++
    }
    if (password[i] == password[i].toLowerCase()) {
         countLowerCase++
    }
  }
}

if (countLowerCase == 0) {
  toast.error('Invalid password, no lower case characters in password')
  return
}

if (countUpperCase == 0) {
  toast.error('Invalid password, no upper case characters in password')
  return
}

if (countDigit == 0) {
  toast.error('Invalid password, no digit characters in password')
  return
}

if (countSpecialCharacters == 0) {
  toast.error('Invalid password, no special characters in password')
  return
}
//Password validation ends

 else  
{
 
 if(actionId==='1')
 {
   //alert(actionId);
  //Insert User Details
  const userparams = JSON.stringify({         
    "Name": inputs.CustName,
    "Username": inputs.CustUserName,
    "Email": inputs.CustEmail,
    "PhoneNumber":inputs.CustMobile,
    "Password":inputs.CustPassword,
    "ConfirmPassword":inputs.CustPassword,
    "Role":"Customer",
    "createdBy": "admin",   
     "ParentID": 0  

     });
      //alert(userparams);
     //Insert Customer Details
     const params = JSON.stringify({
      
        "accountID": 0,
        "company": inputs.CustName,
        "gstNumber": inputs.GSTNumber, 
        "contactName": inputs.ContactPerson,
        "contactPhone": inputs.ContactNumber,
        "contactEmail": inputs.ContactEmail,
        "website": inputs.CustCompanyWebsite,
        "customerTypeID": custType,
        "fullName": inputs.CustName,
        "userName": inputs.CustUserName,
        "address": inputs.CustAddress,
        "city": inputs.CustCity,
        "pinCode": inputs.CustPinCode,
        "is_Active": 1,
        "countryID": countryId,
        "stateID": stateId,
        "mobileNo": inputs.CustMobile,
        "email": inputs.CustEmail,
        "createdBy": "admin",
        "ParentID": 0       
     
  });
     //alert(params);
    console.log(AUTH_URL+'Register');
    //alert(AUTH_URL+'Register');
    //alert(params);
    const API_URL=aPIURL();
    //User Registration start
    //alert(AUTH_URL+'Register');
    axios.post(AUTH_URL+'Register', userparams, {            
    "headers": 
    {
         "content-type": "application/json",   
    },
    })
    .then(function (response) 
    {
       
         console.log(response.data);
         
         if(response.data.statusCode === 200 && response.data.validStatus === true)   
         {
       
          //console.log(params);
         
                  //customer registration start
                  axios.post(API_URL+'GPSCustomerInsert', params, {

                   "headers": 
                    {
                        "content-type": "application/json",    
                    },
                    })
                    .then(function (response) 
                    {
                            if(!response.data.validStatus)
                            {
                                  //alert("customer saved");
                                  toast.error(response.data.message);
                                  //return;                                       
                            }
                            else
                            {
                              
                                  // alert(response.data.message);
                                  toast.success(response.data.message);
                                  console.log("---------------------save--------------------------");
                                  handleAddCustomerClear();                                
                          }      
                    })
                    .catch(function (error) 
                    {
                          toast.error("Some Error occured while saving customer record,Please Provide Valid Inputs.");                  
                          console.log(error.message);    
                    });
                    console.log("---------------------end saved------------------------");   
                   
          } 
          else
          {
            
            toast.error(response.data.message);
          }               
   
    })
    .catch(function (error) 
    {
        //toast.error("Some Error occured while saving User record, Please Provide Valid Input.");                   
        console.log(error);    
    });
    //user Registration ends     
  } 
  else
  {
       //Update Device Details
     const params = JSON.stringify({
      //"id": this.state.DID,
            
    "accountID": custID,
    "company": inputs.CustName,
    "gstNumber": inputs.GSTNumber, 
    "contactName": inputs.ContactPerson,
    "contactPhone": inputs.ContactNumber,
    "contactEmail": inputs.ContactEmail,
    "website": inputs.CustCompanyWebsite,
    "customerTypeID": custType,
    "fullName": inputs.CustName,
    "userName": inputs.CustUserName,
    "address": inputs.CustAddress,
    "city": inputs.CustCity,
    "pinCode": inputs.CustPinCode,
    "is_Active": 1,
    "countryID": countryId,
    "stateID": stateId,
    "mobileNo": inputs.CustMobile,
    "email": inputs.CustEmail,
    "createdBy": "admin"    
    });

     axios.post(API_URL +'GpsCustomersEdit', params, {

         "headers": 
         {
                "content-type": "application/json",    
         },

    })
      .then(function (response) 
      {
        if(!response.data.validStatus)
        {
                 toast.error(response.data.message);
                 //return;
        }
        else
        {
              
              toast.success(response.data.message);
              console.log(response.data);
        }                       
           
      })

      .catch(function (error) 
      {
            
            toast.error("Some Error occured while saving customer record, Please Provide valid Inputs");
            console.log(error);    
      });
        //console.log(this.state);
        handleUpdateCustomerClear();
            
            
  }
}
}
const onClickLogin=()=>
{
      
     const params = JSON.stringify({

        "Username":inputs.CustUserName,       
        "Role": "Admin",
        "UserType": "Admin",
            
      });
     
      const AUTH_URL=auTHURL();
      
        	axios.post(AUTH_URL+'ExternalLogin', params,
		      {        
          	"headers": {          
          	"content-type": "application/json",          
          	},          
          	})
          .then(function(response) 
          {                 
                  console.log("--------------start-------------------");  
                  //console.log(response.data);            
                  if(JSON.parse(JSON.stringify(response.data.message))==='Logged in')
                  {
                          
                           setUserSession(response.data.token, response.data.userName,response.data.userRole,response.data.actorID,response.data.name);
                           //alert("apprt");
                          //navigate('/Apprt');
                                                   
                          history('/VehicleMonitor'); // self Route//
                          
                  }   
                  else
                  {       
                          removeUserSession();
                          console.log("---------Error----------");
                         // console.log(response.data.message);
                          toast.error(response.data.message,{ position: "bottom-right", autoClose: 4000, theme: "light"});                         
                  }           
           })
          
          .catch(function(error) 
          {
                  removeUserSession();
                  alert(error);
                  alert(JSON.stringify(error.data));
                  console.log(error);
          
          });        
        
 }


const handleAddCustomerClear=()=>
  {

     setInputs({});
     setCustID('0'); 
     setActionId('1'); 
     setDActionname('Save');
     setStateId(''); 
     setCountryId('1');              
     setCustomerData([]); 
     setChangePass(false);         
     //bind device details grid
     bindCustomerDetails();    
     
  }
  const handleUpdateCustomerClear=()=>
  {
       //bind device details grid
       bindCustomerDetails();        
  }
  
  const exportStatus = e => {
    const value = e.target.value;
    setCustTypeId(e.target.value);
    FillGrid(value);
  }
const CustNamechangeHandler=(e)=>
{
      setCustName(e.target.value)
}
const CustMobilechangeHandler=(e)=>
{
     const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value))
        {
             setCustMobile(e.target.value)
        }
        else
        {
           setCustMobile('');
        }
}
const ChangeTypeHandler = e => {
      const value = e.target.value;
      setCustomerTypeId(e.target.value);      
  }
const FilterGrid=()=>
  {
     setPost([]);
     const curls=API_URL+`GpsAdminCustomerAllList/?TypeID=${custTypeId}&CustomerTypeID=${customerTypeId}&CustomerName=${custName}&CustomerMobile=${custMobile}`;            
     axios.post(curls).then(response => {       
              setPost(response.data.data);
     }).catch(function(error)
     {
         console.log(error.message);
     });      
  }
const ResetList=()=>
  {
        setCustTypeId(0);
        setCustomerTypeId(0);
        setCustName("");
        setCustMobile("");
        FillGrid(0);
  }
  const exportToCSV=()=>
    {
      const newPost = post.map(({ accountID,cAddress,status,pincode,parentId,userMax,customerTypeId, ...rest }) => rest);
       const ws= XLSX.utils.json_to_sheet(newPost);        
       var wscols = [
          {wch:5} ,
          {wch:30},
          {wch:30},
          {wch:20},
          {wch:30},
          {wch:30},
          {wch:20},    
          {wch:20},
          {wch:20}
      ];
   
      var wsrows = [
         {hpx: 30}
      ];
      
      ws['!cols'] = wscols;
      ws['!rows']=wsrows;
           
      let Heading = [['S.No.','Customer Name','Company Name','Mobile Number','Email','UserName','Country','State','City']];
      const wb={Sheets:{Customers:ws},SheetNames:["Customers"]};
      XLSX.utils.sheet_add_aoa(ws, Heading);     
      const excelBuffer= XLSX.write(wb,{bookType:"xlsx",type:"array"});
      const data= new Blob([excelBuffer],{type:fileType});
      FileSaver.saveAs(data,"AvtCustomerReport"+".xlsx");
     }

  const exportDownload = e => 
  {  
  
  const value = e.target.value; 
  //alert(value)
  
  if(value=="Excel")
  {
         exportToCSV();  
       //onDownload();
  }
  if(value=="PDF")
  {
        handlePrint(null, () => tableRef.current);
  }
  }
  /*const { onDownload } = useDownloadExcel({
  currentTableRef: tableRef.current,
  filename: "CustomerDetails",
  sheet: "Customers"
  });*/
  const handlePrint = useReactToPrint({
  documentTitle: "Customer Details",
  onBeforePrint: () => console.log("before printing..."),
  onAfterPrint: () => console.log("after printing..."),
  removeAfterPrint: true,
  });
   
  return (
<>     

<Modal isOpen={showDetails} > 
      <div class="modal-header">
                <h5 className='modal-title'>Customer Details</h5>
                <button type="button" class="btn-close"  onClick={closeModal}></button>
                </div>
                <div class="modal-body">                        
                <div class="row">
                 <table >
                {filteredCustomerDetails.map(custdata1 => ( <tr key={custdata1.accountID}>
                    <td>                    
                    <div class="row">                  
	                <div class="col-sm-6 col-md-4 form-group">&nbsp;              
		            <b> Customer Name : </b>      
                    {custdata1.customerName}
		            </div>
                <div class="col-sm-6 col-md-4 form-group">&nbsp; 
                    <b> Mobile Number : </b>        
                    {custdata1.mobileNo}
		            </div>
                <div class="col-sm-6 col-md-4 form-group">&nbsp; 
		            <b> Email : </b>       
                    {custdata1.email}
		            </div>
                <div class="col-sm-6 col-md-4 form-group">&nbsp; 
                    <b> Country : </b>        
                    {custdata1.countryName}
		            </div>
                    <div class="col-sm-6 col-md-4 form-group">&nbsp; 
                    <b> State : </b>        
                    {custdata1.stateName}
		            </div>
                    <div class="col-sm-6 col-md-4 form-group">&nbsp; 
                    <b>City : </b>      
                    {custdata1.city}
		            </div>
                    <div class="col-sm-6 col-md-4 form-group">&nbsp; 
                    <b> PinCode : </b>        
                    {custdata1.pincode}
		            </div>
                <div class="col-sm-6 col-md-4 form-group">&nbsp; 
                <b> Customer Type : </b>        
                {custdata1.customerType}
		            </div>
                <div class="col-sm-6 col-md-4 form-group">&nbsp; 
                <b> UserMax : </b>        
                {custdata1.userMax}
		            </div></div>               
                </td>                            
                </tr>
                 ))}
                </table>
                
                <table class="table table-striped table-bordered table-hover">
                <thead> 
                <tr>
                <th>Sell Date</th> 
                {/* <th> Sold To</th> */}
                <th>Device Name</th>
                <th>IMEI Number</th>            
                <th>Subscribtion Type</th>                     
                </tr>
                </thead>
                <tbody>
                {allotedDeviceByCustID.map(devalldata => (
                <tr key={devalldata.allotmentID}>
                <td>{devalldata.allotmentDate}</td> 
                <td>{devalldata.deviceName}</td>
                <td>{devalldata.imeiNumber}</td>                
                <td>{devalldata.subscribeName}</td>                      
                </tr>
              ))}      
               </tbody>
               </table>         
               </div>
                </div>
</Modal>  
<Modal isOpen={showAddDetails} >  
 <div class="modal-header">
 <h5 className='modal-title'>Customer Details</h5>
 <button type="button" id="closeAddCustomerModal" class="btn-close" onClick={closeAddCustomerModal}></button>
 </div>
 <div class="modal-body"> 
 <div class="row">
 {/**/} 
 <div class="col-sm-12 col-md-12 form-group">
 <div style={{ "fontSize":"16px" }} onChange={setCustomerType.bind(custType)}>
 <input type="radio" disabled={redioDispl} value="1" name="customerType" checked={custType === 1?true:false}/> Individual 
 &nbsp;&nbsp;<input type="radio" disabled={redioDispl} value="2" name="customerType" checked={custType === 2?true:false}/> Company
 &nbsp;&nbsp;<input type="radio" disabled={redioDispl} value="3" name="customerType" checked={custType === 3?true:false}/> Distributor
 <span style={{float: 'right'}}>
 <button type="submit" id="ExLogin" onClick={onClickLogin} className="btn btn-primary2" style={{ display: mLogincDisplay}}>Member Login</button>  </span>  
 </div>
 </div>       
</div> 
<span style={{"border-bottom": "1px solid #dadada", padding: "5px" ,"margin-bottom":"10px",fontSize:"14px", display: cDisplay }}><b>{cNameLevel} Details </b> </span>                      
<div class="row">
<div class="col-sm-4 col-md-4 form-group" >
{cNameLevel} Name:<span style={{color:"red"}}>&nbsp;*</span>        
<input name="CustName"  type="text" required="required"  className="form-control"  value={inputs.CustName} onChange={changeHandler} ></input>
</div>
<div class="col-sm-4 col-md-4 form-group" style={{display: cDisplay }}>
Website:
<input name="CustCompanyWebsite" type="text" required="required" className="form-control" value={inputs.CustCompanyWebsite} onChange={changeHandler} ></input>
</div>
<div class="col-sm-4 col-md-4 form-group" style={{display: cDisplay}}>
GST Number:      
<input name="GSTNumber"  type="text" required="required"  className="form-control"  value={inputs.GSTNumber} onChange={changeHandler} ></input>
</div>
<div class="col-sm-4 col-md-4 form-group">
Mobile Number:<span style={{color:"red"}}>&nbsp;*</span>
<input name="CustMobile" type="text" required="required" className="form-control" maxLength={10} value={inputs.CustMobile} onChange={changeHandler} ></input>
</div>
<div class="col-sm-4 col-md-4 form-group">
Email:<span style={{color:"red"}}>&nbsp;*</span>
<input name="CustEmail" type="text" required="required" className="form-control" value={inputs.CustEmail} onChange={changeHandler} ></input>
</div>
<div class="col-sm-4 col-md-4 form-group">
Country:<span style={{color:"red"}}>&nbsp;*</span>
<select className="form-control" name="DCountry" value={countryId} onChange={ChangeCountryD}  >
<option>Select Country</option>
{countryData.map((e, key) => {
return <option key={key} value={e.id}>{e.country_Name}</option>;
})}
</select>
</div>
<div class="col-sm-4 col-md-4 form-group">
State:<span style={{color:"red"}}>&nbsp;*</span>
<select className="form-control slct" name="DState" value={stateId} onChange={ChangeStateD} >
<option>Select State</option>
{stateData.map((e, key) => {
return <option key={key} value={e.id}>{e.state_Name}</option>;
})}
</select>
</div>
<div class="col-sm-4 col-md-4 form-group">
City:<span style={{color:"red"}}>&nbsp;*</span>        
<input name="CustCity"  type="text" required="required"  className="form-control"  value={inputs.CustCity} onChange={changeHandler} ></input>
</div>
<div class="col-sm-4 col-md-4 form-group">
PinCode:<span style={{color:"red"}}>&nbsp;*</span>        
<input name="CustPinCode"  type="text" required="required"  maxLength={6} className="form-control" value={inputs.CustPinCode} onChange={changeHandler} ></input>
</div>
<div class="col-sm-4 col-md-4 form-group">
User Max:<span style={{color:"red"}}>&nbsp;*</span>        
<input name="CustUserMax"  type="text" required="required"  maxLength={2} className="form-control" disabled value={userMax}  onChange={changeHandler} ></input>
</div>
<div class="col-sm-4 col-md-4 form-group">
Address
<textarea name="CustAddress" type="text" className="form-control" value={inputs.CustAddress} onChange={changeHandler} rows={2} cols={20} />
 </div> 	
<span style={{"border-bottom": "1px solid #dadada", padding: "5px" ,"margin-bottom":"10px",fontSize:"14px", display: cDisplay }}><b>Contact Details </b> </span> 
<div class="col-sm-4 col-md-4 form-group" style={{display: cDisplay }}>
Contact Person:
<input name="ContactPerson" type="text" required="required" className="form-control" value={inputs.ContactPerson} onChange={changeHandler} ></input>
</div>
<div class="col-sm-4 col-md-4 form-group" style={{display: cDisplay }}>
Contact Number:
<input name="ContactNumber" type="text" required="required" maxLength={10} className="form-control" value={inputs.ContactNumber} onChange={changeHandler} ></input>
</div>
<div class="col-sm-4 col-md-4 form-group" style={{display: cDisplay }}>
Contact Email:
<input name="ContactEmail" type="text" required="required" className="form-control" value={inputs.ContactEmail} onChange={changeHandler} ></input>
</div>
<span style={{"border-bottom": "1px solid #dadada", padding: "5px" ,"margin-bottom":"10px",fontSize:"14px" }}><b>User/Login Details </b> </span> 
<div class="col-sm-4 col-md-4 form-group">
User/Login Name:<span style={{color:"red"}}>&nbsp;*</span>        
 <input name="CustUserName"  type="text" required="required"  className="form-control" placeholder='User/Login Name Used for login' disabled={changePass} value={inputs.CustUserName} onChange={changeHandler} ></input>
</div>
<div class="col-sm-4 col-md-4 form-group">
Password:<span style={{color:"red"}}>&nbsp;*</span>        
 <input name="CustPassword"  type="text" required="required"   className="form-control" value={inputs.CustPassword} onChange={changeHandler} ></input>
</div>	
<div class="col-sm-4 col-md-4 form-group" style={{marginTop: "27px"}}>
<button type="submit" id="Save" onClick={onClickResetPassword} className="btn btn-danger" style={{display: resetPassword }}>Reset Password </button>
</div>
<div class="col-sm-12 col-md-12 form-group">
 <center>
 <button type="submit" id="Save" onClick={onClickRegister} className="btn btn-primary2">{dActionname} </button>     
 </center>
 </div></div></div>
 </Modal>
 <div className="top-bar clearfix">
 <div className="row">
 <div className="col-md-4"><h2> Customers</h2></div>
 <div className="col-md-8 text-right">
 <button type="submit" id="showAddCustomerDetails" onClick={() => showAddCustomerDetails()} className="btn btn-new"> New </button>
  <select onChange={exportStatus} className="btn btn-primary" name="Export">
  <option value={"0"}>All</option>    
  <option value={"1"}>Enabled</option>  
  <option value={"2"}>Disabled</option>                
  </select>
  <select onChange={exportDownload} name="DGroup" className="btn btn-primary"  >
  <option value={"Download"}>Download</option>    
  <option value={"Excel"}>Excel</option>    
  <option value={"PDF"}>PDF</option>                      
  </select>
  </div>
  </div>
  </div>
  <div className="container-fluid p-3">
  <div class="card mb-3 shadow no-border border-0">
  <div class="card-body">
  <div class="row align-items-end">  
  <div class="col-sm-3 col-lg-2">CUSTOMER TYPE 
  <select onChange={ChangeTypeHandler} class="form-control" value={customerTypeId} name="CustomerTyprID">
  <option value={"0"}>All</option>    
  <option value={"1"}>Individual</option>  
  <option value={"2"}>Company</option>     
  <option value={"3"}>Distributor</option>             
  </select>
  </div>
  <div class="col-sm-3 col-lg-2">CUSTOMER NAME <input type="text" class="form-control" tabindex="1" id="txtCustomerName"   maxlength="50" value={custName} onChange={CustNamechangeHandler}/>
  </div>
  <div class="col-sm-3 col-lg-2">MOBILE NUMBER <input type="text" class="form-control" tabindex="2" id="txtMobileNo"   maxlength="10" value={custMobile} onChange={CustMobilechangeHandler}/>
  </div>    
  <div class="col-sm-4 col-lg-2">
  <button type="button" class="btn btn-primary2 mt-20" tabindex="3" id="btnSearchNew" onClick={FilterGrid} >Search</button>
  <button type="button" class="btn btn-secondary mt-20" id="btnResetNew" tabindex="4" onClick={ResetList}>Reset
  </button></div>
  <div class="col-sm-3 col-lg-2"> </div>
  </div></div></div>
  <div className="container-fluid p-3">
  <div class="card mb-3 shadow no-border border-0">
  <div class="card-body p-0">
  <table ref={tableRef} id="example" class="table table-striped table-bordered table-hover" style={{width:"100%"}}>
  <thead>
  <tr>    
               <th style={{textAlign:"center"}}>S.No. </th>    
               <th onClick={()=>sorting("customerType") } style={{textAlign:"center","cursor": "pointer"}}>Customer Type &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>        
                <th onClick={()=>sorting("customerName") } style={{textAlign:"center","cursor": "pointer"}}>Customer Name &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th onClick={()=>sorting("mobileNo") } style={{textAlign:"center","cursor": "pointer"}}>Mobile Number &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i> </th>
                <th onClick={()=>sorting("email") } style={{textAlign:"center","cursor": "pointer"}}>Email &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th onClick={()=>sorting("countryName") } style={{textAlign:"center","cursor": "pointer"}}>Country &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i> </th>
                <th onClick={()=>sorting("stateName") } style={{textAlign:"center","cursor": "pointer"}}>State &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th onClick={()=>sorting("city") } style={{textAlign:"center","cursor": "pointer"}}>City &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th onClick={()=>sorting("pincode") } style={{textAlign:"center","cursor": "pointer"}}>PinCode &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th onClick={()=>sorting("userName") } style={{textAlign:"center","cursor": "pointer"}}>UserName &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>                
                <th onClick={()=>sorting("accountID") } style={{textAlign:"center"}}>Action </th>
  </tr>
  </thead>
  <tbody>
  {currentPost.map((custdata) => {
              return (                  
              <tr key={custdata.id}>
              <td style={{textAlign:"center"}}>{custdata.id}</td>   
              <td>{custdata.customerType}</td> 
              <td>{custdata.customerName}</td>
              <td style={{textAlign:"center"}}>{custdata.mobileNo}</td>
              <td>{custdata.email}</td>             
              <td>{custdata.countryName}</td>
              <td>{custdata.stateName}</td>
              <td>{custdata.city}</td>
              <td style={{textAlign:"center"}}>{custdata.pincode}</td>
              <td>{custdata.userName}</td>
              <td style={{textAlign:"center", fontSize:"16px"}}>
              <i onClick={() => showDetailsModal(custdata.accountID)} style={{ color:"green", cursor:'pointer'}} className="fa-solid fa-list" title="View Details"></i>
              &nbsp;&nbsp; <i onClick={() => handleEdit(custdata.accountID)} style={{ color:"#fd0691", cursor:'pointer'}} className="fa-solid fa-pen-to-square" title="Update Details"></i>
              </td>
              </tr>           
            );
          })}          
          </tbody>
          </table>    
          <ReactPaginate previousLabel={"<<"}  nextLabel={">>"}  pageCount={PageCount} onPageChange={ChangePage} disableInitialCallback={true}  initialPage={0}  containerClassName={'pagination justify-content-end'}
          pageClassName={'page-item'}  pageLinkClassName={'page-link'}  previousClassName={'page-item'}  previousLinkClassName={'page-link'}  nextClassName={'page-item'}  nextLinkClassName={'page-link'}  breakClassName={'page-item'}
          breakLinkClassName={'page-link'}  activeClassName={'active'}></ReactPaginate>       
          </div> </div></div></div> 
          <ToastContainer position="bottom-right" autoClose={4000} theme="light"/>    
    </>
    );
    }

export default CustomerList;
